module.exports = __webpack_public_path__ + "img/15-27-166.dbd0712a.png";